import { validateCompliance } from "utils";

export const auditorFields = [
  {
    label: '',
    id: 'auditorComment',
    name: 'auditorComment',
    type: 'textarea',
    rows: 10,
    maxLength: 1000,
    rules: [
      { required: true, message: <div>Το πεδίο είναι υποχρεωτικό</div> },
    ],
    asterisk: false,
  },
];